// @flow
import type { Product } from 'digicel-kaizen-library';
import type { FetchPromoProductsRequestActionType, SetPromoProductsActionType } from './types';

export const fetchPromoProductsRequest = (): FetchPromoProductsRequestActionType => ({
  type: 'FETCH_PROMO_PRODUCTS_REQUEST',
});

export const setPromoProducts = (promoProducts: Product[]): SetPromoProductsActionType => ({
  type: 'SET_PROMO_PRODUCTS',
  payload: { promoProducts },
});
